<script setup>
import { ref, computed, watch } from 'vue'
import { useTranslaterStore } from '@/stores/translater'

defineProps({
    isRight: {
        required: true,
        type: Boolean
    }
})

const emit = defineEmits(['setEventsMarkers'])

const translaterStore = useTranslaterStore()

const showList = ref(false)
const isCheckAll = ref(true)

const mapEvents = ref([
    { id: 1, value: 'UTACarMapEvent_secure', title: 'CAR_MAP_EVENT_SECURE', subTitle: 'CAR_MAP_EVENT_SECURE_ADD', isActive: true },
    { id: 2, value: 'UTACarMapEvent_engine', title: 'CAR_MAP_EVENT_ENGINE', subTitle: 'CAR_MAP_EVENT_ENGINE_ADD', isActive: true },
    { id: 3, value: 'UTACarMapEvent_trunk', title: 'CAR_MAP_EVENT_TRUNK', subTitle: 'CAR_MAP_EVENT_TRUNK_ADD', isActive: true },
    { id: 4, value: 'UTACarMapEvent_zone', title: 'CAR_MAP_EVENT_ZONE', subTitle: 'CAR_MAP_EVENT_ZONE_ADD', isActive: true },
    { id: 5, value: 'UTACarMapEvent_light', title: 'CAR_MAP_EVENT_LIGHT', subTitle: '', isActive: true },
    { id: 6, value: 'UTACarMapEvent_mileage', title: 'CAR_MAP_EVENT_MILEAGE', subTitle: '', isActive: true },
    { id: 7, value: 'UTACarMapEvent_voltage', title: 'CAR_MAP_EVENT_VOLTAGE', subTitle: '', isActive: true },
])

const getTranslate = computed(() => translaterStore.getTranslate)
const eventsData = computed(() => mapEvents.value.filter(el => el.isActive).map(el => el.value))

function toggleList() {
    showList.value = !showList.value
}

function setEvent(idx) {
    mapEvents.value[idx].isActive = !mapEvents.value[idx].isActive

    emit('setEventsMarkers', eventsData.value)
}

function setAllEvents(val) {

    mapEvents.value.map(el => el.isActive = val)

    emit('setEventsMarkers', eventsData.value)
}

watch(eventsData, (arr) => {
    if (arr.length === 0) {
        isCheckAll.value = false
    }
})

watch(isCheckAll, newVal => {
    if(newVal == true) {
        setAllEvents(true)
    } else {
        setAllEvents(false)
    }
})
</script>

<template>
    <div 
        class="uta-car-map-events"
        :class="{ 'uta-car-map-events--active': showList }"
    >

        <div class="uta-car-map-events__header">
          
            <div class="switcher uta-car-map-events__switcher">
                <input 
                    class="switcher__input" 
                    type="checkbox" 
                    id="UTACheckAll" 
                    v-model="isCheckAll"
                    @change="checkUserAttr"
                >
                <label 
                    class="switcher__label uta-car-map-events__switcher-label" 
                    for="UTACheckAll"
                >
                    <span class="switcher__text uta-car-map-events__switcher-text">{{ getTranslate.CAR_MAP_EVENTS }}</span>
                </label>
            </div>

            <button class="uta-car-map-events__toggle" @click="toggleList">
                <span 
                    class="uta-car-map-events__icon"
                    :class="{ 
                        'uta-car-map-events__icon--active' : showList && !isRight, 
                        'uta-car-map-events__icon--active-right' : showList && isRight
                    }"
                >
                    <span class="material-icons"> expand_more </span>
                </span>
            </button>
        </div>

        <transition name="translateY" appear>
            <div 
                v-if="showList"
                class="uta-car-map-events__list"
                :class="{'uta-car-map-events__list--disabled' : !isCheckAll, 'right': isRight && showList }"
            >
                <button 
                    type="button" 
                    class="d-block d-sm-none btn-close list-close"
                    @click="toggleList"
                >
                </button>

                <div class="uta-car-map-events__wrapper">
                    <form class="uta-car-map-events__form">
                        <div
                            v-for="(item, idx) in mapEvents"
                            :key="item.id"
                            class="form-check"
                        >
                            <input 
                                type="checkbox" 
                                class="form-check-input uta-car-map-events__form-input" 
                                :value="item.value" 
                                :checked="item.isActive"
                                :id="'car-map-events-' + idx"
                                @change="setEvent(idx)"
                            > 
                            <label 
                                class="form-check-label uta-car-map-events__form-label" 
                                :class="{'uta-car-map-events__form-label--dimmed' : !isCheckAll }"
                                :for="'car-map-events-' + idx"
                            >
                                {{ getTranslate[item.title] }}
                                <span class="uta-car-map-events__form-sublabel">
                                    {{ getTranslate[item.subTitle] }}
                                </span>
                            </label>
                        </div>
                    </form>
                </div>
            </div>
        </transition>
    </div>
</template>

<style lang="scss">
@import '@/assets/styles/scss/components/car/car-map-events';
</style>